import curry from "../../../lib/core/functional/curry";

const renderModule = curry(function renderReorderModule({ h }, _context, _deps, _altLoader) {
    function Module(props) {
        const { onOrderChange, selectedOrder } = props;
        return (
            <div class="comment-sort">
                Sort by
                <select
                    onChange={onOrderChange}
                    name="sort"
                    class="comment--sort"
                    aria-label="Sort comments by..."
                >
                    <option value="newest" selected={selectedOrder === "newest"}>
                        Newest
                    </option>
                    <option value="oldest" selected={selectedOrder === "oldest"}>
                        Oldest
                    </option>
                    <option value="best" selected={selectedOrder === "best"}>
                        Popular
                    </option>
                </select>
            </div>
        );
    }
    return Module;
});

export default function reorder({ preact }) {
    return renderModule(preact);
}
